/**
 * Positioners - are the objects responsible for initial positiong of windows
 * 
 * They folow the Decorator pattern, where you can introduce your own Positioner and decoreate one of the already supplied
 * 
 * @author Vladimir Dosen <vlada.dosen@gmail.com>
 * 
 * @param {Object} wind
 * @returns {DefaultPositioner}
 */


var DefaultPositioner = function(wind) {
    var window = wind;
    this.setWindow = function(w) {
        window = w;
        return this;
    };
    this.getWindow = function() {
        return window;
    };
    this.position = function(){return this.getWindow();};
};



var PositionerDecorator = function(positioner) {
    this.positioner = positioner;
};


var BorderLineDecorator = function(positioner, params){
    BorderLineDecorator.prototype.parent.call(this, positioner);
    var parameters = params;
    this.getParameters = function() {
        return parameters;
    };
};
BorderLineDecorator.prototype              = new PositionerDecorator();
BorderLineDecorator.prototype.parent       = PositionerDecorator;
BorderLineDecorator.prototype.constructor  = BorderLineDecorator;
BorderLineDecorator.prototype.position = function(callback) {
    var window = this.positioner.position();
    window.getElement().css(this.getParameters());
    if(callback) {
        callback();
    }
    return window;
};

var OutOfSiteDecorator = function(positioner, direct, css){
    OutOfSiteDecorator.prototype.parent.call(this, positioner);
    var direction = direct;
    var cascading_style_sheets = css;
    this.getDirection = function() {
        return direction;
    };
    this.getCss = function() {
        return cascading_style_sheets;
    };
};
OutOfSiteDecorator.prototype              = new PositionerDecorator();
OutOfSiteDecorator.prototype.parent       = PositionerDecorator;
OutOfSiteDecorator.prototype.constructor  = OutOfSiteDecorator;
OutOfSiteDecorator.prototype.position = function(callback) {
    var window = this.positioner.position();
    window.getElement().css(this.getDirection(), 0);
    switch(this.getDirection()) {
        case 'right':
        case 'left':
            window.getElement().css(this.getDirection(), -1*window.getElement().outerWidth());
            
            break;
        case 'top':
        case 'bottom':
            window.getElement().css(this.getDirection(), -1*window.getElement().outerHeight());
            break;
                
    }
    if(typeof this.getCss() !== "undefined") {
        window.getElement().css(this.getCss());
    }
    if(callback) {
        callback();
    }
    return window;
};